module.exports = __webpack_public_path__ + "static/maquette2-4b88ddc252d7a1e558be7d58a98cce9b.jpg";